import {
  GET_CHECKERS_REQUEST,
  GET_CHECKERS_SUCCESS,
  GET_CHECKERS_FAIL,
  GET_CHECKERS_RESET,
  CREATE_CHECKER_REQUEST,
  CREATE_CHECKER_SUCCESS,
  CREATE_CHECKER_FAIL,
  CREATE_CHECKER_RESET,
  UPDATE_CHECKER_REQUEST,
  UPDATE_CHECKER_SUCCESS,
  UPDATE_CHECKER_FAIL,
  UPDATE_CHECKER_RESET,
  DELETE_CHECKER_REQUEST,
  DELETE_CHECKER_SUCCESS,
  DELETE_CHECKER_FAIL,
  DELETE_CHECKER_RESET,
  ASSIGN_EVENTS_REQUEST,
  ASSIGN_EVENTS_SUCCESS,
  ASSIGN_EVENTS_FAIL,
  ASSIGN_EVENTS_RESET,
} from '../constants/checkerConstants'

export const getCheckersReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CHECKERS_REQUEST:
      return { loadingGetCheckers: true }
    case GET_CHECKERS_SUCCESS:
      return { loadingGetCheckers: false, checkersData: action.payload }
    case GET_CHECKERS_FAIL:
      return { loadingGetCheckers: false, errorGetCheckers: action.payload }
    case GET_CHECKERS_RESET:
      return {}
    default:
      return state
  }
}

export const createCheckerReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_CHECKER_REQUEST:
      return { loadingCreateChecker: true }
    case CREATE_CHECKER_SUCCESS:
      return { loadingCreateChecker: false, createCheckerData: action.payload }
    case CREATE_CHECKER_FAIL:
      return { loadingCreateChecker: false, errorCreateChecker: action.payload }
    case CREATE_CHECKER_RESET:
      return {}
    default:
      return state
  }
}

export const updateCheckerReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_CHECKER_REQUEST:
      return { loadingUpdateChecker: true }
    case UPDATE_CHECKER_SUCCESS:
      return { loadingUpdateChecker: false, updateCheckerData: action.payload }
    case UPDATE_CHECKER_FAIL:
      return { loadingUpdateChecker: false, errorUpdateChecker: action.payload }
    case UPDATE_CHECKER_RESET:
      return {}
    default:
      return state
  }
}

export const deleteCheckerReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_CHECKER_REQUEST:
      return { loadingDeleteChecker: true }
    case DELETE_CHECKER_SUCCESS:
      return { loadingDeleteChecker: false, deleteCheckerData: action.payload }
    case DELETE_CHECKER_FAIL:
      return { loadingDeleteChecker: false, errorDeleteChecker: action.payload }
    case DELETE_CHECKER_RESET:
      return {}
    default:
      return state
  }
}

export const assignEventsReducer = (state = {}, action) => {
  switch (action.type) {
    case ASSIGN_EVENTS_REQUEST:
      return { loadingAssignEvents: true }
    case ASSIGN_EVENTS_SUCCESS:
      return { loadingAssignEvents: false, assignEventsData: action.payload }
    case ASSIGN_EVENTS_FAIL:
      return { loadingAssignEvents: false, errorAssignEvents: action.payload }
    case ASSIGN_EVENTS_RESET:
      return {}
    default:
      return state
  }
}
